import { Injectable } from "@angular/core";
import { User } from "./../../services/user.service";
import { AppSettingsService } from "./../app-settings.service";

const MockUser = {
  firstName: "John",
  lastName: "Doe",
  middleName: "D",
  suffix: "SR",
  userId: "104D6DEE-7E36-4718-B366-7432C1F7815C",
  personId: "856359",
  email: "test@tet.com",
  beginDate: "",
  endDate: "",
  credentialHolder: false,
  status: "",
  hasBadPayment: false,
  invalidCRTDate: false,
  credentialHolderExpiredGracePeriod: false,
  instance: "ALPHA",
  subjectToCMP: false,
  revokedCRT: false,
  hasExpiredCredentials: false,
  provisional: false,
  hasRT: false,
  underNBRCJE: false,
  hasHoursAndCanRecertify: false,
};

@Injectable()
export class AuthMocksService {
  readonly email: string;
  readonly password: string;
  readonly user: User;

  constructor(private appSettings: AppSettingsService) {
    this.email = "mock@test.com";
    this.password = "mock";
    this.user = MockUser;
  }

  createSignInResponse(): any {
    return {
      body: { token: this.createValidToken() },
      status: 200,
      headers: null,
      url: "",
      merge: null,
    };
  }

  createForgotPasswordResponse(): any {
    return {
      body: { token: this.createValidToken() },
      status: 200,
      headers: null,
      url: "",
      merge: null,
    };
  }

  createResetPasswordResponse(): any {
    return {
      body: { token: this.createValidToken() },
      status: 200,
      headers: null,
      url: "",
      merge: null,
    };
  }

  createChangePasswordResponse(): any {
    return {
      body: { success: true },
      status: 200,
      headers: null,
      url: "",
      merge: null,
    };
  }

  createValidToken(): string {
    const claims = {
      portalUser: JSON.stringify(this.user),
      iat: 1483228800000,
    };

    if (this.appSettings.IsDebugEnabled)
      {console.error({ mockUser: claims.portalUser });}

    const jwt = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9."
      .concat(this.base64Encode(JSON.stringify(claims)))
      .concat(".sWZyBgimV41U-R2I96yj5-Cv8bG0bIpVfHAw3oVM7yQ");
    /*
    Mock token using server secret:
    eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwb3J0YWxVc2VyIjp7ImVtYWlsIjoidGVzdEB0ZXN0LmNvbSIsImZpcnN0TmFtZSI6IkpvaG4iLCJsYXN0TmFtZSI6IkRvZSIsImlkIjoxMjM0NTYsInJvbGUiOiJQcm9ncmFtIERpcmVjdG9yIiwic2Nob29scyI6W3siaWQiOjEwMDAwMCwibmFtZSI6IlRlc3QgU2Nob29sIDEifSx7ImlkIjoyMDAwMDAsIm5hbWUiOiJUZXN0IFNjaG9vbCAyIn0seyJpZCI6MzAwMDAwLCJuYW1lIjoiVGVzdCBTY2hvb2wgMyJ9LHsiaWQiOjQwMDAwMCwibmFtZSI6IlRlc3QgU2Nob29sIDQifSx7ImlkIjo1MDAwMDAsIm5hbWUiOiJUZXN0IFNjaG9vbCA1In1dfSwiaWF0IjoxNDgzMjI4ODAwMDAwfQ.sWZyBgimV41U-R2I96yj5-Cv8bG0bIpVfHAw3oVM7yQ
    */

    return jwt;
  }

  private base64Encode(input: string): string {
    return window.btoa(input).replace(/=/g, "");
  }
}
